import { IconName } from '@shared/components/core/images/IconMap';
import Icons from '@shared/components/core/images/Icons';
import { Article, Details, Subtitle, Summary } from './CoreDetailsDiscloreStyles';

interface IDetailsDisclosureProps {
    icon?: IconName;
    title: string;
    subtitle?: string;
    children: React.ReactNode;
}

export default function DetailsDisclosure({ icon, title, subtitle, children }: IDetailsDisclosureProps) {
    return (
        <Details>
            <Summary>
                {icon && <Icons name={icon} />}
                {title}
                {subtitle && <Subtitle>{subtitle}</Subtitle>}
            </Summary>
            <Article>{children}</Article>
        </Details>
    );
}
